import createIcon from '../../createIcon';

/**
 * @component @name PresentToAll
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMjEgM0gzQzEuODkgMyAxIDMuODkgMSA1VjE5QzEgMjAuMTEgMS44OSAyMSAzIDIxSDIxQzIyLjExIDIxIDIzIDIwLjExIDIzIDE5VjVDMjMgMy44OSAyMi4xMSAzIDIxIDNaTTIxIDE5LjAySDNWNC45OEgyMVYxOS4wMlpNMTAgMTJIOEwxMiA4TDE2IDEySDE0VjE2SDEwVjEyWiIgZmlsbD0iYmxhY2siLz4KPC9zdmc+Cg==)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const PresentToAll = createIcon('PresentToAll', [
  [
    'path',
    {
      d: 'M21 3H3C1.89 3 1 3.89 1 5V19C1 20.11 1.89 21 3 21H21C22.11 21 23 20.11 23 19V5C23 3.89 22.11 3 21 3ZM21 19.02H3V4.98H21V19.02ZM10 12H8L12 8L16 12H14V16H10V12Z',
      key: '5gzn6u',
    },
  ],
]);

export default PresentToAll;
